/* eslint-disable no-fallthrough */
import { IDBPDatabase, openDB } from 'idb';

let dbPromise: Promise<IDBPDatabase> | null = null;

function openIndexDB(): Promise<IDBPDatabase> {
  if (!('indexedDB' in globalThis)) {
    return Promise.reject(new Error('IndexedDB is not available in this environment'));
  }
  return openDB('brightscrip', 8, {
    upgrade(db, oldVersion) {
      switch (oldVersion) {
        case 0:
          db.createObjectStore('ChainsStore');
        case 1:
          db.createObjectStore('EtlRoutesStore');
        case 2:
          db.createObjectStore('PharmaciesSearchStore');
        case 3:
          db.createObjectStore('PharmaciesSimpleSearchStore');
        case 4:
          db.createObjectStore('ProductsStore');
        case 5:
          db.createObjectStore('ProgramGroupsStore');
        case 6:
          db.createObjectStore('SettingsStore');
        case 7:
          db.createObjectStore('PrescribersSimpleSearchStore');
      }
    },
    terminated() {
      // Browser dropped the connection — force reconnect on next access
      dbPromise = null;
    },
  });
}

export function getIndexDB(): Promise<IDBPDatabase> {
  if (!dbPromise) {
    dbPromise = openIndexDB().catch(err => {
      dbPromise = null;
      throw err;
    });
  }
  return dbPromise;
}
